module.exports = __webpack_public_path__ + "static/media/sprite_bean-blue.3f19a50d.svg";